import { jsPDF } from 'jspdf';
import { formatCurrency } from './formatters';
import { getInstagramDataURL } from './imageGenerator';
import { getLogoBase64 } from './imageUtils';

export const downloadPropertyPDF = async (data, generatedDescription) => {
  const doc = new jsPDF({
    orientation: 'p',
    unit: 'mm',
    format: 'a4'
  });

  const primaryColor = [6, 78, 59]; // Emerald 900
  const accentColor = [16, 185, 129]; // Emerald 500
  const textColor = [31, 41, 55]; // Gray 800

  // --- HEADER ---
  doc.setFillColor(...primaryColor);
  doc.rect(0, 0, 210, 45, 'F');

  try {
    const base64Logo = await getLogoBase64();
    doc.setFillColor(255, 255, 255);
    doc.roundedRect(15, 7, 30, 30, 5, 5, 'F');
    const padding = 3;
    doc.addImage(base64Logo, 'PNG', 15 + padding, 7 + padding, 30 - (padding * 2), 30 - (padding * 2));
    
    doc.setTextColor(255, 255, 255);
    doc.setFontSize(16);
    doc.setFont('helvetica', 'bold');
    doc.text('ARBOLEDA BIENES RAÍCES', 52, 20);
    
    doc.setFontSize(10);
    doc.setFont('helvetica', 'normal');
    doc.text('Honduras - Catálogo de Propiedades', 52, 28);
  } catch (e) {
    doc.setTextColor(255, 255, 255);
    doc.setFontSize(22);
    doc.setFont('helvetica', 'bold');
    doc.text('ARBOLEDA HN', 20, 25);
  }

  // --- IMAGEN PRINCIPAL ---
  if (data.images?.length > 0) {
    try {
      const coverImage = await getInstagramDataURL(data);
      doc.addImage(coverImage, 'PNG', 45, 55, 120, 120);
    } catch (err) {
      console.error("PDF Image Error", err);
    }
  }

  // --- DETALLES ---
  doc.setTextColor(...textColor);
  doc.setFontSize(20);
  doc.setFont('helvetica', 'bold');
  doc.text(`${data.propertyType} en ${data.operation}`, 20, 190);

  doc.setTextColor(...accentColor);
  doc.setFontSize(18);
  doc.text(formatCurrency(data.price, data.currency), 20, 200);

  doc.setDrawColor(240, 240, 240);
  doc.line(20, 206, 190, 206);
  
  doc.setFontSize(9);
  doc.setTextColor(120, 120, 120);
  
  const isTerreno = data.propertyType === 'Terreno';
  const hasBedrooms = ['Casa', 'Departamento'].includes(data.propertyType);
  const parkingCount = Number(data.parking) || 0;
  
  const col1 = 20, col2 = 65, col3 = 110, col4 = 155;
  const rowY = 213;
  const valueY = 220;

  if (isTerreno) {
    doc.text('TIPO', col1, rowY);
    doc.text('ÁREA TOTAL', col3, rowY);
  } else if (hasBedrooms) {
    doc.text('HABITACIONES', col1, rowY);
    doc.text('BAÑOS', col2, rowY);
    doc.text('ÁREA', col3, rowY);
  } else {
    doc.text('BAÑOS', col1, rowY);
    doc.text('PARQUEOS', col2, rowY);
    doc.text('ÁREA', col3, rowY);
  }
  doc.text('UBICACIÓN', col4, rowY);

  doc.setTextColor(...textColor);
  doc.setFontSize(11);
  
  if (isTerreno) {
    doc.text('TERRENO / LOTE', col1, valueY);
  } else if (hasBedrooms) {
    doc.text(String(data.bedrooms || '0'), col1, valueY);
    doc.text(String(data.bathrooms || '0'), col2, valueY);
  } else {
    doc.text(String(data.bathrooms || '0'), col1, valueY);
    // Lógica de Parqueo en Tabla: Si es 0, mostrar "N/A" o "0" de forma clara
    doc.text(parkingCount > 0 ? String(parkingCount) : '0', col2, valueY);
  }
  
  doc.text(`${data.area || '0'} ${data.areaUnit || (isTerreno ? 'v²' : 'm²')}`, col3, valueY);
  doc.text(data.city, col4, valueY);

  // Descripción
  doc.setFontSize(10);
  doc.setFont('helvetica', 'bold');
  doc.text('DESCRIPCIÓN DETALLADA', 20, 235);
  
  doc.setFont('helvetica', 'normal');
  doc.setFontSize(9);
  
  const stripEmojis = (str) => {
    if (!str) return '';
    return str.replace(/[\u{1F600}-\u{1F64F}\u{1F300}-\u{1F5FF}\u{1F680}-\u{1F6FF}\u{1F700}-\u{1F77F}\u{1F780}-\u{1F7FF}\u{1F800}-\u{1F8FF}\u{1F900}-\u{1F9FF}\u{1FA00}-\u{1FA6F}\u{1FA70}-\u{1FAFF}\u{2600}-\u{26FF}\u{2700}-\u{27BF}\u{1F1E6}-\u{1F1FF}]/gu, '');
  };

  const safeDescription = stripEmojis(generatedDescription || 'No se proporcionó descripción.');
  const splitDesc = doc.splitTextToSize(safeDescription, 170);
  doc.text(splitDesc, 20, 242);

  // --- FOOTER ---
  doc.setFillColor(245, 245, 245);
  doc.rect(0, 275, 210, 22, 'F');
  
  doc.setTextColor(...primaryColor);
  doc.setFontSize(9);
  doc.setFont('helvetica', 'bold');
  doc.text('ASESOR DE VENTAS:', 20, 283);
  
  doc.setTextColor(...textColor);
  doc.setFont('helvetica', 'normal');
  doc.text(`${data.agentName} | Tel: ${data.agentPhone} | ${data.agentEmail}`, 20, 289);

  doc.save(`Arboleda_${data.city}_${Date.now()}.pdf`);
};